<nav class="navbar navbar-expand-lg navbar-light flex-nowrap" style="border-radius: .5rem; background-color: lightgray; height: 3rem">
    <a class="navbar-brand flex-nowrap" href="#">Entry {{current + 1}} of {{count}}</a>
    <ul class="navbar-nav mr-auto">
      <li><a class="nav-link" (click)="gotoStart()" [class.disabled]='atStart()'><i class='fa fa-fast-backward'></i></a></li>
      <li><a class="nav-link" (click)="goPrevious()" [class.disabled]='atStart()'><i class='fa fa-chevron-left'></i></a></li>
      <li><a class="nav-link" (click)="goNext()" [class.disabled]='atEnd()'><i class='fa fa-chevron-right'></i></a></li>
      <li><a class="nav-link" (click)="gotoEnd()" [class.disabled]='atEnd()'><i class='fa fa-fast-forward'></i></a></li>
    </ul>
</nav>